import styled from 'styled-components';
import { rhythm } from 'Themes/typography';

const MenuContainer = styled.div`
  display: flex;
  // align-items: center;
  // padding-bottom: ${rhythm(1)};
  // svg {
  //   position: absolute;
  //   right: 10px;
  //   top: 25px;
  // }
`;

export default MenuContainer;
